import ClearingAPI from '@shared/api';

export const {
    clientDetails: { get: getMethods, put: putMethods },
} = ClearingAPI.settings;
